import React, { Component } from "react";
import { message, Typography } from "antd";
import axios from "axios";
import { connect } from "react-redux";
import {
  Form,
  ModalItem,
  FormItem,
  InputNumberItem,
  SelectInsumosItem,
  ButtonItem,
  ErrorItem,
  NotificacionPolizas,
  NotificacionMovimientosInventario,
} from "../../../../../Components/Items";
import ElegirLotes from "../../../LotesCaducidades/ElegirLotes/ElegirLotes";

const { Text } = Typography;

class CambiarInsumoVenta extends Component {
  formRef = React.createRef();
  cantidadNuevaTocada = false;
  state = {
    loading: false,
    insumoNuevoSeleccionado: null,
    disponibleNuevo: null,
    lotesSeleccionados: [],
    modalElegirLotesVisible: false,
    cantidadNuevaValue: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible && this.props.visible) {
      this.cantidadNuevaTocada = false;
      this.setState({
        insumoNuevoSeleccionado: null,
        disponibleNuevo: null,
        lotesSeleccionados: [],
        modalElegirLotesVisible: false,
        cantidadNuevaValue: this.props.entregado,
      });
      this.formRef.current?.resetFields();
    }
  }

  cerrarCambiarInsumo(refrescar) {
    this.props.cerrarCambiarInsumo(refrescar);
  }

  onFinishFailed(e) {
    ErrorItem(e);
  }

  async consultarDisponibilidad(insumoId, insumo) {
    if (!insumoId) return;
    try {
      const res = await axios.post(
        "inventarios/inventarioInsumoProyecto",
        {
          proyectoId: this.props.proyectoId,
          insumoId,
          noPrincipal: insumo?.noPrincipal,
          insumoCompuesto: insumo?.insumoCompuesto,
          empresaId: this.props.empresaId,
        },
        { headers: this.props.headersToken }
      );
      this.setState({ disponibleNuevo: res.data.cantidad ?? 0 });
    } catch (e) {
      this.setState({ disponibleNuevo: 0 });
    }
  }

  onChangeInsumoNuevo(value, insumo) {
    this.setState({
      insumoNuevoSeleccionado: insumo || null,
      disponibleNuevo: null,
      lotesSeleccionados: [],
    });
    this.consultarDisponibilidad(value, insumo);
  }

  onChangeCantidadDevuelta(value) {
    if (!this.cantidadNuevaTocada) {
      this.formRef.current.setFieldsValue({ cantidadNueva: value });
      this.setState({ cantidadNuevaValue: value });
    }
  }

  onChangeCantidadNueva(value) {
    this.cantidadNuevaTocada = true;
    this.setState({ cantidadNuevaValue: value });
  }

  abrirElegirLotes() {
    if (!this.state.insumoNuevoSeleccionado) {
      message.warning("Selecciona primero el insumo de reemplazo.");
      return;
    }
    this.setState({ modalElegirLotesVisible: true });
  }

  cerrarElegirLotes(lotesFiltrados) {
    this.setState({ lotesSeleccionados: lotesFiltrados || [], modalElegirLotesVisible: false });
  }

  onFinish(values) {
    const requiereLotes = this.state.insumoNuevoSeleccionado?.lotesCaducidades;

    if (requiereLotes) {
      const sumaLotes = this.state.lotesSeleccionados.reduce(
        (suma, valueLote) => suma + (valueLote.cantidadRequerida || 0),
        0
      );
      if (this.state.lotesSeleccionados.length === 0 || sumaLotes < values.cantidadNueva) {
        message.warning("Selecciona los lotes del insumo de reemplazo por la cantidad completa a entregar.");
        return;
      }
    }

    if (this.state.disponibleNuevo !== null && values.cantidadNueva > this.state.disponibleNuevo) {
      message.warning("No hay suficiente inventario disponible del insumo de reemplazo en este proyecto.");
      return;
    }

    this.setState({ loading: true });
    axios
      .post(
        "ventas/cambiarInsumoVenta",
        {
          insumoIdNuevo: values.insumoIdNuevo,
          cantidadDevuelta: values.cantidadDevuelta,
          cantidadNueva: values.cantidadNueva,
          lotes: requiereLotes ? this.state.lotesSeleccionados : undefined,
          empresaId: this.props.empresaId,
          ventaId: this.props.ventaId,
          insumoVentaId: this.props.insumoVentaId,
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Se cambió el insumo");
          NotificacionPolizas(res.data.polizasId);
          NotificacionMovimientosInventario(res.data.movimientosIds);
          this.cerrarCambiarInsumo(true);
        } else {
          message.error(res.data.message || "Sucedió un error y no se cambió el insumo");
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Sucedió un error y no se cambió el insumo");
      });
  }

  render() {
    const requiereLotes = this.state.insumoNuevoSeleccionado?.lotesCaducidades;
    const sinInventario = this.state.disponibleNuevo === 0;

    return (
      <>
        <ModalItem
          title="Cambiar Insumo"
          visible={this.props.visible}
          spinning={this.state.loading}
          onCancel={() => this.cerrarCambiarInsumo(false)}
          paddingTop
          destroyOnClose
          width="60%"
        >
          <Form
            ref={this.formRef}
            name="cambiarInsumoVenta"
            layout
            bottom={
              <ButtonItem
                type="primary"
                htmlType="submit"
                disabled={sinInventario}
                style={{ display: "block", margin: "0 0 0 auto" }}
              >
                Cambiar Insumo
              </ButtonItem>
            }
            onFinish={this.onFinish.bind(this)}
            onFinishFailed={this.onFinishFailed}
          >
            <FormItem label="Insumo Original" margin>
              <SelectInsumosItem
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                tiposInsumos="inventariables"
                width="100%"
                disabled
                value={this.props.insumoId}
                onChange={() => {}}
              />
            </FormItem>

            <FormItem
              label="Cantidad a Devolver"
              name="cantidadDevuelta"
              required
              number
              margin
              max={this.props.entregado}
              type="number"
              initialValue={this.props.entregado}
              tooltip="No puede ser mayor a la cantidad ya entregada al cliente de esta línea."
            >
              <InputNumberItem
                min={0}
                max={this.props.entregado}
                placeholder={"Max: " + (this.props.entregado || 0)}
                onChange={this.onChangeCantidadDevuelta.bind(this)}
              />
            </FormItem>

            <FormItem
              label="Insumo de Reemplazo"
              name="insumoIdNuevo"
              required
              margin
            >
              <SelectInsumosItem
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                tiposInsumos="inventariables"
                width="100%"
                placeholder="Selecciona el insumo que se entrega a cambio"
                onChange={this.onChangeInsumoNuevo.bind(this)}
              />
            </FormItem>

            {this.state.insumoNuevoSeleccionado ? (
              <div style={{ marginTop: -10, marginBottom: 15 }}>
                <Text type={sinInventario ? "danger" : "secondary"}>
                  {this.state.disponibleNuevo === null
                    ? "Consultando inventario disponible..."
                    : `Disponible en este proyecto: ${this.state.disponibleNuevo}`}
                </Text>
                {requiereLotes ? (
                  <div style={{ marginTop: 8 }}>
                    <ButtonItem type="default" onClick={this.abrirElegirLotes.bind(this)}>
                      Elegir Lotes
                      {this.state.lotesSeleccionados.length > 0
                        ? ` (${this.state.lotesSeleccionados.length} seleccionados)`
                        : ""}
                    </ButtonItem>
                  </div>
                ) : null}
              </div>
            ) : null}

            <FormItem
              label="Cantidad a Entregar (insumo nuevo)"
              name="cantidadNueva"
              required
              number
              margin
              max={this.state.disponibleNuevo === null ? undefined : this.state.disponibleNuevo}
              type="number"
              initialValue={this.props.entregado}
            >
              <InputNumberItem
                min={0}
                max={this.state.disponibleNuevo === null ? undefined : this.state.disponibleNuevo}
                placeholder="Cantidad a entregar"
                onChange={this.onChangeCantidadNueva.bind(this)}
              />
            </FormItem>
          </Form>
        </ModalItem>

        <ElegirLotes
          visible={this.state.modalElegirLotesVisible}
          insumoId={this.state.insumoNuevoSeleccionado?._id}
          proyectoId={this.props.proyectoId}
          ventaId={this.props.ventaId}
          cantidad={this.state.cantidadNuevaValue}
          lotes={this.state.lotesSeleccionados}
          cerrarElegirLotes={this.cerrarElegirLotes.bind(this)}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(CambiarInsumoVenta);
